<app-basic-grid *ngIf="hasNotes" [configuration]="configuration" [data]="notes"></app-basic-grid>